import * as React from 'react'

import { Box, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeSelector from 'modules/core/components/EmployeeSelector'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'
import type ImportEmployeesToSMForm from 'modules/shift_management/lib/forms/ImportEmployeesToSMForm'
import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'
import numberOfRestDaysOptions from 'modules/time_planning/lib/numberOfRestDaysOptions'

import AddEmployeesNoticeBox from '../AddEmployeesNoticeBox'
import type { IdsType, IdsTypes } from './useImportEmployeesSM'

interface Props {
  form: ImportEmployeesToSMForm
  selectableEmployees: Employee[]
  onSelectEmployee: (id: IdsTypes) => void
  selectedEmployeeIds: IdsType
  contractVersions: ContractVersions
}

const FormContent = ({
  form,
  selectableEmployees,
  onSelectEmployee,
  selectedEmployeeIds,
  contractVersions,
}: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasRestDays = hasFeatureFlag(ShiftManagementFeatureFlags.SHIFT_MANAGEMENT_REST_DAY)
  const [open, toggle] = React.useState<boolean>(false)
  const onChangeNumberOfRestDaysCheckbox = (value: boolean) => {
    if (!value) {
      form.get('number_of_rest_days_in_cents').set(null)
    }

    toggle(value)
  }

  return (
    <Box gap="s16">
      <EmployeeSelector
        employees={selectableEmployees}
        onSelectEmployee={onSelectEmployee}
        onSelectMultiple={onSelectEmployee}
        selectedEmployeeIds={selectedEmployeeIds}
        virtualized
        contractVersions={contractVersions}
      />
      <AddEmployeesNoticeBox />
      <DayPicker
        field={form.get('effective_at')}
        label={i18n.t('shift_management.import_employees.effective_date')}
        minDate={minDate}
        maxDate={maxDate}
      />
      {hasRestDays && (
        <>
          <TogglerCheckbox
            label={i18n.t(
              'time_planning.planning_versions.forms.apply_number_of_rest_days_checkbox'
            )}
            value={open}
            onChange={onChangeNumberOfRestDaysCheckbox}
          />
          {open && (
            <Select
              field={form.get('number_of_rest_days_in_cents')}
              label={i18n.t('time_planning.planning_versions.forms.number_of_rest_days')}
              options={numberOfRestDaysOptions()}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default observer(FormContent)
